import { MenuItem } from '../../services/dataService';

export const isItemFeatured = (item: MenuItem) =>
  Boolean(item.isFeatured || item.isSpecialOffer || item.isTodaysSpecial);

export const isItemPopular = (item: MenuItem) =>
  Boolean(
    (item.popularityScore && item.popularityScore > 50) ||
      item.badges?.includes('Bestseller') ||
      item.badges?.includes('Popular')
  );
